import styled from "styled-components";
import { Row, Col, Select, Card, Tabs } from "antd";
import { COLORS } from "../../constants/colors";

export const StoreContainer = styled.div`
    width: 100%;
    background-color: #f3f3f1;
    max-width: 700px;
    padding: 15px;
    margin: auto;
`;

export const DashboardContainer = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 12px;
    padding-bottom: 150px;

    .ant-row {
        width: 100%;
        margin: 0 !important; // Reset ant-design margins
    }
`;

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); // Makes cards responsive
    gap: 24px; // Increased gap slightly to make spacing more uniform
    margin-bottom: 24px;
`;


export const ChartContainer = styled.div`
    background: white;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    margin-bottom: 5rem;
`;

export const MetricCard = styled.div`
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    background: ${({ isActive, color }) =>
        isActive ? `linear-gradient(145deg, white, ${color}0a)` : 'white'};
    border: ${({ isActive, color }) =>
        isActive ? `2px solid ${color}` : '1px solid #eee'};
    height: 100%;  // Changed from fixed height to 100%
    width: 100%;   // Added to ensure full width
    cursor: pointer;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 768px) {
        padding: 12px;
        margin: 0;
        min-height: 100px; // Minimum height for mobile
    }
`;

export const MetricInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
`;

export const MetricLabel = styled.div`
  font-size: 14px;
  color: #6c757d;
  display: flex;
  align-items: center;
  
  span {
    margin-left: 8px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const MetricValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin: 8px 0;
//   color: ${({ positive }) => positive ? '#28a745' : '#dc3545'};
color: black;
`;

export const PercentageChange = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ positive }) => positive ? '#28a74520' : '#dc354520'};
  color: ${({ positive }) => positive ? '#28a745' : '#dc3545'};

  .anticon {
    margin-right: 4px;
  }
`;

export const SparklineWrapper = styled.div`
  width: 120px;
  height: 40px;
`;

export const ComparisonContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
`;

// Keep your existing styled components
export const StyledRow = styled(Row)`
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #F2F7FF;
    padding: 10px 0;
    border-top: 1px solid #e8e8e8;
    border-radius: 10px 10px 0 0;
`;

export const StyledCol = styled(Col)`
    text-align: center;
    position: relative;
    &:not(:last-child)::after {
        content: '';
        position: absolute;
        right: 0;
        top: 10%;
        height: 80%;
        width: 1px;
        background-color: #e8e8e8;
    }
`;

export const ButtonLabel = styled.div`
    font-size: 14px;
    color: ${COLORS.$black};
`;

export const HeaderTypography = styled.div`
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
`;

export const TimeframeSelect = styled(Select)`
    width: 200px;
    margin-bottom: 20px;
`;

export const CustomCard = styled(Card)`
    border-radius: 20px;
    margin: 10px 0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: ${({ active, color }) => active ? `2px solid ${color}` : 'none'};
    background: ${({ active }) => active ? 'linear-gradient(to bottom, white, rgba(255, 255, 255, 0.8))' : 'none'};
    min-height: 120px;

    @media (max-width: 768px) {
        min-height: 150px;
    }
`;

export const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

export const MetricContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SparklineContainer = styled.div`
    width: 100%;
    height: 30px;
    margin-top: 10px;
`;

export const IconTextContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 5px;
`;

export const EmptyStateContainer = styled.div`
    background: white;
    padding: 32px;
    border-radius: 8px;
    text-align: center;
`;

export const StyledCardTabs = styled(Tabs)`
  /* We do NOT set background or color for the inactive tabs here,
     so they remain the default Ant Design color.
     That means we only style the active tab below. */

  &.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active {
    background-color: #000; /* Black background for active tab */
    color: #fff!important;            /* White text for active tab */
    border-color: #444;     /* Optional darker border for active tab */
  }

  &.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #fff!important;            /* White text for active tab */
    font-weight: 600;
  }

  /* (Optional) If you want to tweak the hover color for inactive tabs:
  &.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active):hover {
    background-color: #f5f5f5;
  }
  */

  /* (Optional) If you want to style the tab content area:
  &.ant-tabs-card > .ant-tabs-content {
    border: 1px solid #e8e8e8;
  }
  */
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  margin-top: 8px;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 16px;
  }

  .ant-pagination {
    margin: 0; // Remove default margin
    
    .ant-pagination-item-active {
      background: black;
      border-color: black;
      
      a {
        color: white;
      }
    }

    .ant-pagination-item:hover {
      border-color: black;
      
      a {
        color: black;
      }
    }

    .ant-pagination-prev:hover .ant-pagination-item-link,
    .ant-pagination-next:hover .ant-pagination-item-link {
      border-color: black;
      color: black;
    }
  }
`;

// Right side container for select and text
export const PageSizeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (max-width: 576px) {
    width: 100%;
    justify-content: center;
  }
`;

// Styled Select with better focus and hover states
export const StyledSelect = styled(Select)`
  &.ant-select {
    width: 80px;
    
    .ant-select-selector {
      border-radius: 6px;
      transition: all 0.2s;
      
      &:hover {
        border-color: black;
      }
    }
    
    &.ant-select-focused .ant-select-selector {
      border-color: black !important;
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    }
  }

  // Style the dropdown menu
  .ant-select-dropdown {
    .ant-select-item-option-selected {
      background-color: rgba(0, 0, 0, 0.06);
      font-weight: 600;
    }

    .ant-select-item-option-active {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;

// Text with proper contrast
export const ItemsPerPageText = styled.span`
  color: #666;
  font-size: 14px;
  white-space: nowrap;
`;